
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/conjure/ios-newsletter",
      function () {
        return require("private-next-pages/conjure/ios-newsletter.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/conjure/ios-newsletter"])
      });
    }
  